import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function Nav({ dark, setDark }) {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="container">
        <div className="navbar-brand">
          <NavLink to="/" className="navbar-item brand-mark" onClick={() => setOpen(false)}>
            QuizGarden
          </NavLink>

          <button
            type="button"
            className={`navbar-burger ${open ? 'is-active' : ''}`}
            aria-label="menu"
            aria-expanded={open ? 'true' : 'false'}
            onClick={() => setOpen(!open)}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div className={`navbar-menu ${open ? 'is-active' : ''}`}>
          <div className="navbar-end">
            <NavLink
              to="/"
              className={({ isActive }) => `navbar-item ${isActive ? 'is-active' : ''}`}
              onClick={() => setOpen(false)}
            >
              Home
            </NavLink>
            <NavLink
              to="/highscores"
              className={({ isActive }) => `navbar-item ${isActive ? 'is-active' : ''}`}
              onClick={() => setOpen(false)}
            >
              High Scores
            </NavLink>
            <div className="navbar-item">
              <button className="button is-small is-light" onClick={() => setDark(!dark)} type="button">
                {dark ? 'Light Mode' : 'Dark Mode'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
